import { Permissions } from 'Permission';
import { PermissionGate } from 'PermissionContext';
import React from 'react';
import SidebarItem, { SidebarItemProps } from '../Sidebar/SidebarItem';

export interface PermissionSidebarItemProps extends SidebarItemProps {
  permissionKey: Permissions;
}

export default function PermissionSidebarItem({
  permissionKey,
  ...rest
}: PermissionSidebarItemProps) {
  return (
    <PermissionGate permissionKey={permissionKey}>
      <SidebarItem {...rest} />
    </PermissionGate>
  );
}
